import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { SalesLetterSection } from '../components/SalesLetterSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { BonusSection } from '../components/BonusSection';
import { PricingOfferSection } from '../components/PricingOfferSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { FooterSection } from '../components/FooterSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
      window.fbq('init', '891090260291826');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="bg-primary min-h-screen text-white selection:bg-crimson selection:text-white" data-id="element-205">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-206">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=891090260291826&ev=PageView&noscript=1" alt="" data-id="element-207" />
      </noscript>

      <StickyAlertBar data-id="element-208" />
      <Navbar data-id="element-209" />
      <HeroSection data-id="element-210" />
      <SalesLetterSection data-id="element-211" />
      <WhatYouGetSection data-id="element-212" />
      <BonusSection data-id="element-213" />
      <PricingOfferSection data-id="element-214" />
      <SocialProofSection data-id="element-215" />
      <FooterSection data-id="element-216" />
    </div>;
}